import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import signatureLogo from '../img/dj-signature-light.svg';

function Header() {
  return (
    <div className="w-full bg-dj-dark md:flex md:flex-row md:pt-0 relative overflow-hidden items-center justify-center md:min-h-screen">
      {/* Neon Grid Background */}
      <div className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(0deg, transparent 24%, rgba(111, 159, 248, 0.3) 25%, rgba(111, 159, 248, 0.3) 26%, transparent 27%, transparent 74%, rgba(111, 159, 248, 0.3) 75%, rgba(111, 159, 248, 0.3) 76%, transparent 77%, transparent),
            linear-gradient(90deg, transparent 24%, rgba(247, 36, 68, 0.3) 25%, rgba(247, 36, 68, 0.3) 26%, transparent 27%, transparent 74%, rgba(247, 36, 68, 0.3) 75%, rgba(247, 36, 68, 0.3) 76%, transparent 77%, transparent)
          `,
          backgroundSize: '100px 100px',
          backgroundPosition: '0 0, 0 0',
          transform: 'rotate(15deg)'
        }}
      />
      
      <div className="md:w-full md:px-20 px-4 py-12 md:py-12 pb-32 md:pb-0 relative z-0">
        <div className="max-w-6xl mx-auto">
          <img 
            src={signatureLogo} 
            alt="Signature" 
            className="w-80 h-56 object-contain"
            style={{ filter: 'brightness(0) saturate(100%) invert(60%) sepia(70%) saturate(1200%) hue-rotate(200deg)' }}
          />
          <h1 className="text-4xl md:text-5xl font-light text-secondary mb-8">
            Derek Johnston
          </h1>
          <h5 className="text-white text-left mb-16 text-2xl md:text-6xl">
            I'm a <span className="text-primary font-bold">Design Strategist</span> working at the intersection of <span className="text-secondary">digital product</span>, <span className="text-secondary">UX</span>, and <span className="text-secondary">AI</span> — with over 15 years building consumer-facing digital products at enterprise and startup scale.
          </h5>
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 -mb-8 md:mb-0">
            <Link to="#case-studies">
              <button className="bg-primary hover:bg-secondary text-dj-dark font-bold py-3 px-8 rounded transition-colors flex items-center gap-2">
                View My Work <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </Link>
            <a href="#contact">
              <button className="border-2 border-primary text-primary hover:bg-primary hover:text-dj-dark font-bold py-3 px-8 rounded transition-colors flex items-center gap-2">
                Get In Touch <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </a>
          </div>
        </div>
      </div>
       {/* <div class="md:w-1/2 md:px-20 md:py-20 px-8 py-24">
        <Floating3D />
      </div> */}
    </div>
  );
}

export default Header;